import { State } from 'src/redux/reducer';
import { isLoaded, isPending, shouldLoad } from 'src/redux/utils';

export const listHistorySelector = (state: State) => state.listHistory.entities;
export const listHistoryStatusSelector = (state: State) =>
  state.listHistory.status;
export const listHistoryLoadedSelector = isLoaded(listHistoryStatusSelector);
export const listHistoryPendingSelector = isPending(listHistoryStatusSelector);
export const shouldListHistorySelector = shouldLoad(listHistoryStatusSelector);
